<template>
  <BaseModal
    :title="$t('pages.messages.labels.importantMessage')"
    :is-open="!!message"
    width="800px"
    hide-close-btn
  >
    <MessageContent :message="message" @click:file="downloadFile" />

    <template #footer>
      <a
        :class="{ 'btn-loading': loading }"
        href="#"
        class="btn btn-regular"
        @click.prevent="$emit('read', message)"
      >
        {{ $t('actions.messageRead') }}
      </a>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/base/BaseModal';
import MessageContent from '@/components/MessageContent';
import messageService from '@/services/message.service';
import { downloadFile } from '@/util/files';

export default {
  name: 'ImportantMessagesModal',

  components: { MessageContent, BaseModal },

  props: {
    message: {
      type: Object,
      default: () => null,
    },

    loading: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    downloadFile(file) {
      messageService.getProfileAttachment(this.message.id, file.id).then((res) => {
        downloadFile(res.data, file.filename);
      });
    },
  },
};
</script>
